import {
  IClientContext,
  IContext,
  TContextKeys,
} from '@infotech-soe/metaschema';

import { CategoryTreeStateEntity } from '../../models/category/categoryTree';
import CategoryViewModel from '../category/view-model/CategoryViewModel';
import { DatasetCurrentState } from '../dataset/view-model/DatasetCurrentState';
import UniqueId from '../uid/UniqueId';

export type ClientContextKeys =
  TContextKeys | 'Row' | 'ParentRow' | 'MasterRow' | 'TreeNode';

type Keys = ClientContextKeys;

export class ClientContext extends Map<Keys, any> {
  public toServerContext(): IContext {
    return {
      Category: this.get('Category'),
      ParentCategory: this.get('ParentCategory'),
      MasterCategory: this.get('MasterCategory'),
      Id: this.get('Id'),
      Parent: this.get('Parent'),
      Master: this.get('Master'),
      SelectedIds: this.get('SelectedIds'),
      ProcessId: this.get('ProcessId'),
      DisplayMode: this.get('DisplayMode'),
      Catalog: this.get('Catalog'),
      HierarchicalParent: this.get('HierarchicalParent'),
      InParams: this.get('InParams'),
    };
  }

  public toClientApiContext(): IClientContext {
    return {
      Category: this.get('Category'),
      ParentCategory: this.get('ParentCategory'),
      MasterCategory: this.get('MasterCategory'),
      Id: this.get('Id'),
      Parent: this.get('Parent'),
      Master: this.get('Master'),
      SelectedIds: this.get('SelectedIds'),
      ProcessId: this.get('ProcessId'),
      DisplayMode: this.get('DisplayMode'),
      Catalog: this.get('Catalog'),
      HierarchicalParent: this.get('HierarchicalParent'),
      InParams: this.get('InParams'),
      Row: this.get('Row'),
      ParentRow: this.get('ParentRow'),
      MasterRow: this.get('MasterRow'),
    };
  }
}

interface IContextService {
  getContext(
    category: CategoryViewModel,
    datasetsState: Record<UniqueId, DatasetCurrentState>,
    datasetId: UniqueId,
    treeState?: CategoryTreeStateEntity
  ): Promise<ClientContext>;
}

export default IContextService;
